import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import WorkspaceContainer, {WorkspaceName} from "../table/workspace/WorkspaceContainer";
import WorkspaceLiteContainer from "../table/workspaceLite/WorkspaceLiteContainer";
import {none, Option, option} from "ts-option";
import SortColumnModel from "../../../model/workspace/SortColumnModel";
import {WildcardFilterColumnType} from "../../../model/workspace/WildcardFilter";
import MaterialSearch from "../../../model/material/MaterialSearch";
import EditMaterialModal from "../table/presenter/material/EditMaterialModal";

type Props = RouteComponentProps<any>;

const defaultSort = option(new SortColumnModel("881e87e9-f3b1-4a90-bd85-b5302ff58e52", "description", true));

interface State {
	/**
	 * If defined, material description edit modal is displayed.
	 */
	materialToEdit: Option<MaterialSearch>;
}

class MaterialWorkspaceContainer extends React.Component<Props, State> {
	refs: {
		workspaceContainer: WorkspaceContainer;
	};

	constructor(props: Props) {
		super(props);
		this.state = {materialToEdit: none};
	}

	render() {
		return (
			<>
				<WorkspaceLiteContainer ref={"workspaceContainer"}
										workspaceName={WorkspaceName.Materials}
										wildcardFilterColumnType={WildcardFilterColumnType.Materials}
										sortable
										defaultSort={defaultSort}
										rowToId={(row) => row.id}
										onRowClick={this.onRowClick}/>
				{this.state.materialToEdit.map(this.renderEditMaterialModal).orNull}
			</>
		)
	}

	renderEditMaterialModal = (material: MaterialSearch) => {
		return <EditMaterialModal material={material} onClose={this.onEditCancel} onSuccess={this.onEditSuccess}/>;
	};

	onRowClick = (rowId: string, rowData: any) => this.setState({materialToEdit: option(MaterialSearch.fromJson(rowData))});

	onEditSuccess = () => {
		this.refs.workspaceContainer.refreshCurrentPage();
		this.onEditCancel();
	};

	onEditCancel = () => this.setState({materialToEdit: none});
}

export default withRouter(MaterialWorkspaceContainer);
